import { render } from "./district-settings.vue?vue&type=template&id=73da0962"
import script from "./district-settings.vue?vue&type=script&lang=js"
export * from "./district-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__